export class ColumnSettings {
  constructor() {
    let c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.assign(this, {
      background: 'none',
      align: 'flex-start',
      vertical: 'flex-start',
      width: {
        type: '%',
        value: 100
      },
      height: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 10,
        paddingBottom: 10
      },
      margin: {
        marginLeft: 10,
        marginRight: 10,
        marginTop: 10,
        marginBottom: 10
      },
      border: {
        borderWidth: 0,
        borderColor: '#000000',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderStyle: 'solid'
      }
    });
    Object.assign(this, c);
  }
}
export const ColumnTypes = {
  settings: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    height: {
      title: 'Height',
      type: 'Size'
    },
    align: {
      title: 'Horizontal Align',
      type: 'FlexJustify'
    },
    vertical: {
      title: 'Vertical Align',
      type: 'FlexAlign'
    }
  },
  spacing: {
    padding: {
      title: 'Padding',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  },
  styles: {
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  }
};